/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Passkey_Create_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to create passkey. Please try again." |
*
* @param {Profile_Security_Passkey_Create_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_passkey_create_error = /** @type {((inputs?: Profile_Security_Passkey_Create_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Passkey_Create_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Erstellen des Passkeys. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Failed to create passkey. Please try again.")
});